import { Box, Card, Skeleton } from "@mui/material";
import React from "react";

export const LTOSetupSkeleton = () => {
  return (
    <Card>
      {Array.from({ length: 5 }, (_, i) => (
        <Box key={i} sx={{ p: 3, m: 3, height: "60px" }}>
          <Skeleton variant="text" height="1.5em" />
        </Box>
      ))}
    </Card>
  );
};
